import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CategoryEditData {
  id?: number;
  label: string;
  import_sons: boolean;
  preselect_playlist: boolean;
  edit_winmedia: boolean;
}

@Component({
  selector: 'app-category-edit',
  templateUrl: './categoryEdit.component.html'
})
export class CategoryEditComponent {

  isEditing: boolean;

  label: string;
  importSons: boolean;
  preselectPlaylist: boolean;
  editWinmediaFlag: boolean;

  constructor(
    public dialogRef: MatDialogRef<CategoryEditComponent>,
    @Inject(MAT_DIALOG_DATA) public dataIn: { element?: CategoryEditData, allCategories?: CategoryEditData[] }
  ) {
    this.isEditing = !!dataIn.element;

    if (dataIn.element) {
      this.label = dataIn.element.label;
      this.importSons = dataIn.element.import_sons;
      this.preselectPlaylist = dataIn.element.preselect_playlist;
      this.editWinmediaFlag = dataIn.element.edit_winmedia;
    } else {
      this.label = '';
      this.importSons = true;
      this.preselectPlaylist = false;
      this.editWinmediaFlag = false;
    }
  }

  isDuplicate(): boolean {
    if (!this.label || !this.dataIn.allCategories) return false;
    const trimmed = this.label.trim().toLowerCase();
    return this.dataIn.allCategories.some(c =>
      c.label.toLowerCase() === trimmed &&
      c.id !== (this.dataIn.element?.id)
    );
  }

  isSaveDisabled(): boolean {
    return !this.label || this.label.trim().length === 0 || this.isDuplicate();
  }

  save() {
    if (this.isSaveDisabled()) return;

    this.dialogRef.close({
      action: 'save',
      data: {
        id: this.dataIn.element ? this.dataIn.element.id : null,
        label: this.label.trim(),
        importSons: this.importSons,
        preselectPlaylist: this.preselectPlaylist,
        editWinmediaFlag: this.editWinmediaFlag
      }
    });
  }

  delete() {
    this.dialogRef.close({
      action: 'delete',
      data: { id: this.dataIn.element.id }
    });
  }

  cancel() {
    this.dialogRef.close();
  }

}
